import * as ActivityCBCService from './activityCBCService.js';
export default ActivityCBCService;
